import { useState } from 'react';

/** Copy text to the clipboard; false when the browser refuses (the link stays selectable to copy by hand). */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

/** A one-time sign-in link to pass on when the email did not arrive, with a button to copy it. */
export function CopyLink(props: { link: string; purpose?: 'invite' | 'reset' }) {
  const verb = props.purpose === 'reset' ? 'reset' : 'set';
  const [copied, setCopied] = useState(false);
  return (
    <div className="notice">
      <label>
        Give them this link to {verb} their password (it works once)
        <input readOnly value={props.link} onFocus={(e) => e.target.select()} />
      </label>
      <button
        type="button"
        className="quiet"
        onClick={() => void copyText(props.link).then(setCopied)}
      >
        {copied ? 'Copied' : 'Copy link'}
      </button>
    </div>
  );
}
